export const WATCHLIST_NAME_MAX_LENGTH = 200;
